import PostReactAction from './PostReactAction';
import PostReactedNotification from './PostReactedNotification';
import ReactionsModal from './ReactionsModal';

export const components = {
  PostReactAction,
  PostReactedNotification,
  ReactionsModal,
};
